<template lang="pug">
.clipboard-images
  div
    div(v-for="{ text, date, pub, url } in clipboardItems", :style="{ 'text-align': 'left', color: 'black' }")
      p(v-if="url")
        a(:href="url", :style="{ color: 'black', 'text-decoration': 'none' }") {{ text }}
        br
        i(v-if="pub") [{{ pub }} &mdash; {{ date }}]
      img(v-else, :src="text.replace(/^img\:/, '')")
  //-div
    div(v-for="text in texts") {{ text }}
    img(v-for="src in images", :src="src")
</template>
<script>
import { mapGetters } from 'vuex';
//import { vuexComputed } from '@/helpers';
export default {
  name: 'clipboard-images',
  computed: {
    ...mapGetters(['clipboardItems']),
    //...vuexComputed('copyImage'),
    texts() {
      const reg = /^img\:/;
      return this.clipboardItems.filter(({ text }) => !reg.test(text)).map(({ text }) => text.replace(reg, ''));
    },
    images() {
      const reg = /^img\:/;
      return this.clipboardItems.filter(({ text }) => reg.test(text)).map(({ text }) => text.replace(reg, ''));
    }
  },
  methods: {
    async click() {
      const { onClipboard, id, text, index, textForClipboard, items, allSelected } = this;
      //console.log('onClipboard', onClipboard, onClipboard[id]);
      let clipboard;
      if (items) {
        clipboard = { ...onClipboard };
        items.forEach(([id, text, index]) => clipboard[id] = (allSelected ? undefined : { text, index }));
      } else {
        clipboard = { ...onClipboard, [id]: onClipboard[id] ? undefined : { text, index } };
      }
      this.onClipboard = clipboard;
      this.copyImage = /^img\:/.test(text);
      const tfc = textForClipboard(clipboard);
      if (tfc) {
        try {
          //console.log('trying to copy...', clipboardText);
          // const div = document.createElement('div');
          // div.innerHTML = clipboardHTML;
          // await this.$copyText(div);
          await this.$copyText(tfc);
          console.log('success');
        } catch (ex) {
          console.log('fail', ex);
        }
      }
    },
    // clipboardItems(clipboard) {
    //   return Object.values(clipboard).filter(v => v).sort((a, b) => a.index - b.index);
    // },
    textForClipboard(clipboard) {
      const { clipboardItems } = this;
      const ci = clipboardItems(clipboard);
      return ci && ci.length && ci.map(({ text }) => text).join('\n\n') || '';
    },
    HTMLForclipboard(clipboard) {
      const { clipboardItems } = this;
      const ci = clipboardItems(clipboard);
      return ci && ci.length && ('<table>' + ci.map(({ text }) => `<tr><td>${ text }</td></tr>`).join('') + '</table>') || '';
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/global';
.clipboard-images {
  position: fixed;
  top: 0;
  left: 0;
  transform: translate3d(-500vw, 0, 0);
  img {
    height: 700px;
    margin: 0.75rem;
  }
}
</style>